var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"a-ButtonCloseModal",attrs:{"aria-label":_vm.accessibleCloseModalBtnLabel},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"invisible"},[_vm._v(_vm._s(_vm.accessibleCloseModalBtnLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }